<template>
    <multiselect
        v-model="dataValue"
        :options="selectOptions"
        label="label"
        track-by="id"
        :multiple="true"
        :close-on-select="false"
    ></multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    components: {
        Multiselect,
    },

    props: {
        value: {
            type: Array,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },

    computed: {
        dataValue: {
            get() {
                return this.value != null
                    ? this.value.map((el) => {
                          return {
                              id: el,
                              label: this.options[el],
                          };
                      })
                    : [];
            },
            set(newValue) {
                this.$emit(
                    "change",
                    newValue.map((el) => {
                        return el.id;
                    })
                );
            },
        },
        selectOptions: {
            get() {
                return Object.entries(this.options).map(([key, option]) => {
                    return {
                        id: key,
                        label: option,
                    };
                });
            },
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
